<template>
  <v-simple-table height="300px" fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th v-for="header in headers" :key="header" class="text-left">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="items.length === 0">
          <td :colspan="headers.length" class="text-center">無數據</td>
        </tr>
        <tr v-for="(item, i) in items" :key="i">
          <td v-for="(header, j) in headers" :key="j">{{ item[header] }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'DataTableV2',
  props: {
    headers: { type: Array, default: () => [] },
    items: { type: Array, default: () => [] },
  }
}
</script>
